/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/ocrPreview.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_OCR } from "../graphql/getOCR.query";
import {
  BARCODE_LOGO,
  BATCH_LOGO,
  LEAF_LOGO,
  DATE_LOGO,
} from "../../../assets/images";
import { toast } from "react-hot-toast";

const log: any = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetOCRMethods extends IPluginMethodMap {
  getOCR(args: any, apiURL: string): Promise<any>;
}

export interface getOCRProps {
  base64Image: string;
  apiURL?: string;
}

export class GetOCRService implements IAgentPlugin {
  readonly methods?: IGetOCRMethods;

  constructor() {
    this.methods = {
      getOCR: this.getOCR.bind(this),
    };
  }

  private _getRes(data: any) {
    let _data: any[] = config?.ListTable?.list;
    _data =
      _data &&
      Array.isArray(_data) &&
      _data.length > 0 &&
      _data.map((item: any, index: number) => {
        if (item?.key === "barcode") {
          return {
            ...item,
            avatar: BARCODE_LOGO,
          };
        } else if (item?.key === "fssaiNO") {
          return {
            ...item,
            avatar: LEAF_LOGO,
          };
        } else if (item?.key === "batch") {
          return {
            ...item,
            avatar: BATCH_LOGO,
          };
        } else if (item?.key === "mfd") {
          return {
            ...item,
            avatar: DATE_LOGO,
          };
        } else return { ...item };
      });
    return {
      fssaiNO: data?.fssai,
      batch: data?.batch,
      mfd: data?.mfgDate,
      barcode: data?.barcode,
      dynamsoftBarcode: data?.dynamsoftBarcode,
      ListTable: {
        list: _data,
      },
    };
  }

  async getOCR(args: getOCRProps) {
    // const graphqlModule = getGraphQLModule();
    // const client = graphqlModule.getClient("graphql-gateway");
    console.log(`args in OCR full provenance service :`, args);
    let updatedBase64 = args?.base64Image && args?.base64Image.split(",");
    updatedBase64 =
      updatedBase64 && Array.isArray(updatedBase64) && updatedBase64.length > 1
        ? updatedBase64[updatedBase64.length - 1]
        : null;

    try {
      const res = await axios.post(
        `${args.apiURL}${config?.getOCREP}`,
        {
          img: updatedBase64,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      // if (client) {
      //   const res = await client.query({
      //     query: GET_OCR,
      //     variables: {
      //       img: updatedBase64,
      //     },
      //   });

      if (res?.data) {
        console.log(`on Success :`, res?.data);
        return this._getRes(res?.data);
      }
      //}
    } catch (err: any) {
      console.log(`on error :`, err);
      toast.error(`${err?.response?.data?.error_message}`, { duration: 3000 });
      // return err;
    }
  }
}
